var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"landingPageResule"},[_c('div',{staticClass:"downloadApp",on:{"click":_vm.handleDownload}},[_vm._v("下载APP")]),_c('div',{staticClass:"browserOpen",on:{"click":_vm.handleClick}},[_vm._v("浏览器打开")])])
}
var staticRenderFns = []

export { render, staticRenderFns }